// config.js
// export default config;

export const TrNumbePrefix = "056031";

// const config = {
//   apiBaseUrl: "http://localhost:5000", // Your API base URL
// };

// const config = {
//   apiBaseUrl: "http://localhost:5000", // Your API base URL
// };

const config = {
  apiBaseUrl: "https://dashboard.iskconeasy.com", // Your API base URL
};


export const AppName = {
  appName: "ISKCON EASY",
};

export default config;
